import type { HTMLAttributes } from 'react';
import styles from './Card.module.css';

type CardProps = HTMLAttributes<HTMLDivElement> & {
  raised?: boolean;
};

/** Card — glass-morphic surface container, the base unit of every panel. */
export default function Card({ raised = false, className, children, ...rest }: CardProps) {
  return (
    <div className={[raised ? styles.raised : styles.card, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}
